import { toLocalDateTimeString } from '@softapps/pms/roster';

/** Local wall times for the roster content endpoints; 00:00–23:00 means a whole working day. */
export function requestTimes(
  start: Date,
  end: Date
): { startString: string; endString: string } {
  const isWholeDay =
    start.getHours() === 0 &&
    start.getMinutes() === 0 &&
    end.getHours() === 23 &&
    end.getMinutes() === 0;
  if (isWholeDay) {
    const day = [start.getFullYear(), start.getMonth(), start.getDate()] as const;
    start = new Date(...day, 8);
    end = new Date(...day, 17);
  }
  return {
    startString: toLocalDateTimeString(start),
    endString: toLocalDateTimeString(end),
  };
}
